export const MODAL_OPEN = 'ResolutionCenter/AccountTakeOverModal/OPEN'
export const MODAL_CLOSE = 'ResolutionCenter/AccountTakeOverModal/CLOSE'
